// extracted by mini-css-extract-plugin
module.exports = {"image":"Picture-image_59c772c1","idle":"Picture-idle_f515093f","small":"Picture-small_35c6b03b","visible":"Picture-visible_5fd16f16","fullSize":"Picture-fullSize_dc865836"};